import { useRealtimePollInterval } from '../realtime/useRealtimePollInterval';
import { isDirectedVideoWaiting } from './directedSteps';
import { useGetDirectedVideoQuery, type DirectedVideoArgs } from './directedVideoApi';

/**
 * The safety read of a directed video while the director writes, a cast picture is being made or
 * the make runs. It runs only while the realtime socket is down (`useRealtimePollInterval`): the
 * event `musicVideo.directed.updated` reads the video again when the socket is up.
 */
export const DIRECTED_VIDEO_POLL_MS = 5000;

/**
 * One directed video of the wizard (`GET .../directed/:uuid`), read again by the realtime event, and
 * polled only while the screen waits for the server and the socket is down.
 */
export function useDirectedVideo(args: DirectedVideoArgs) {
  const query = useGetDirectedVideoQuery(args);
  const video = query.data?.video;
  const waiting = video !== undefined && isDirectedVideoWaiting(video);
  const pollingInterval = useRealtimePollInterval(waiting ? DIRECTED_VIDEO_POLL_MS : 0);
  useGetDirectedVideoQuery(args, { pollingInterval, skip: pollingInterval === 0 });
  return {
    video,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
